export default "__VITE_ASSET__CA$p2QDo__"